import Banner from './Banner';
import Summary from './Summary';
import Team from './Team';
import Problem from './Problem';
import Solution from './Solution';
import MachineLearningServices from './MachineLearningServices';

export { Banner, Summary, Team, Problem, Solution, MachineLearningServices };
